import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { HardHat, ArrowSquareOut } from "@phosphor-icons/react";
import RamsListPanel from "./RamsListPanel";
import PermitsPanel from "./PermitsPanel";
import ToolboxTalksPanel from "./ToolboxTalksPanel";
import DraLogPanel from "./DraLogPanel";

/** Admin job page card: everything H&S for this job (RAMS, permits, talks, operatives' risk assessments). */
export default function JobHsCard({ entityType, entityId, defaultTab = "rams" }) {
  const [lib, setLib] = useState(null);
  useEffect(() => { API.get("/hs/library").then(({ data }) => setLib(data)).catch(() => {}); }, []);
  return (
    <div className="bg-card border border-border rounded-md p-4" data-testid="job-hs-card">
      <div className="flex items-center gap-2 mb-3">
        <HardHat size={18} className="text-amber-500" weight="fill" />
        <h3 className="font-semibold text-sm flex-1">Health &amp; Safety</h3>
        <Link to="/health-safety" className="text-xs text-primary hover:underline inline-flex items-center gap-1" data-testid="job-hs-hub-link">H&amp;S Hub <ArrowSquareOut size={12} /></Link>
      </div>
      <Tabs defaultValue={defaultTab}>
        <TabsList className="h-8">
          <TabsTrigger value="rams" className="text-xs" data-testid="job-hs-tab-rams">RAMS</TabsTrigger>
          <TabsTrigger value="permits" className="text-xs" data-testid="job-hs-tab-permits">Permits</TabsTrigger>
          <TabsTrigger value="talks" className="text-xs" data-testid="job-hs-tab-talks">Toolbox talks</TabsTrigger>
          <TabsTrigger value="dra" className="text-xs" data-testid="job-hs-tab-dra">Risk assessments</TabsTrigger>
        </TabsList>
        <TabsContent value="rams" className="mt-3"><RamsListPanel entityType={entityType} entityId={entityId} embedded /></TabsContent>
        <TabsContent value="permits" className="mt-3"><PermitsPanel entityType={entityType} entityId={entityId} embedded library={lib} /></TabsContent>
        <TabsContent value="talks" className="mt-3"><ToolboxTalksPanel entityType={entityType} entityId={entityId} embedded /></TabsContent>
        <TabsContent value="dra" className="mt-3"><DraLogPanel entityType={entityType} entityId={entityId} embedded /></TabsContent>
      </Tabs>
    </div>
  );
}
